import { Injectable } from '@angular/core';
import { 
  ActivatedRouteSnapshot, 
  Router, 
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isAuthenticated = this.authService.isAuthenticated;

    if (isAuthenticated) {
      // Check for required permissions
      const requiredPermissions = route.data['permissions'] as string[] | undefined;
      if (requiredPermissions && requiredPermissions.length > 0) {
        const hasPermission = this.authService.hasAllPermissions(requiredPermissions);
        if (!hasPermission) {
          // Redirect to unauthorized page
          return this.router.createUrlTree(['/unauthorized']);
        }
      }
      return true;
    }

    // Not authenticated - redirect to login
    return this.router.createUrlTree(['/auth/login'], {
      queryParams: { returnUrl: state.url }
    });
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(childRoute, state);
  }
}
